import { render } from "./Idea_Policy.vue?vue&type=template&id=e6cfbcc0&scoped=true"
import script from "./Idea_Policy.vue?vue&type=script&lang=js"
export * from "./Idea_Policy.vue?vue&type=script&lang=js"

import "./Idea_Policy.vue?vue&type=style&index=0&id=e6cfbcc0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6cfbcc0"]])

export default __exports__